import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { LifeBuoy, Phone, MessageSquare, Heart } from "lucide-react";

export const CrisisDialog = ({ open, onOpenChange }) => {
  const [hotlines, setHotlines] = useState([]);
  const [country, setCountry] = useState("");

  useEffect(() => {
    if (open) {
      api.get("/crisis/hotlines").then(({ data }) => {
        setHotlines(data.hotlines || []);
        setCountry(data.country || "");
      }).catch(() => {});
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-calm border-calm text-calm-text rounded-3xl max-w-lg" data-testid="crisis-dialog">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <span className="w-10 h-10 rounded-full bg-calm-text/10 flex items-center justify-center">
              <Heart className="w-5 h-5 text-calm-text" />
            </span>
            <DialogTitle className="font-serif text-3xl text-calm-text">You are not alone</DialogTitle>
          </div>
          <DialogDescription className="text-calm-text/80 text-base leading-relaxed">
            If you are in immediate danger, please contact your local emergency services.
            These compassionate people are available to talk{country ? ` in ${country}` : ""}, any time.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-2 max-h-[50vh] overflow-y-auto pr-1">
          {hotlines.map((h, i) => (
            <div key={i} className="bg-linen/70 rounded-2xl p-4" data-testid={`hotline-${i}`}>
              <p className="font-medium text-calm-text">{h.name}</p>
              <div className="flex flex-wrap gap-x-5 gap-y-1 mt-1 text-sm text-calm-text/80">
                {h.phone && <span className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" />{h.phone}</span>}
                {h.text && <span className="flex items-center gap-1.5"><MessageSquare className="w-3.5 h-3.5" />{h.text}</span>}
                {h.hours && <span>{h.hours}</span>}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const CrisisButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="crisis-button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 left-6 z-[60] flex items-center gap-2 bg-accent text-linen rounded-full pl-4 pr-5 py-3 shadow-lg hover:bg-accent-hover hover:-translate-y-0.5 transition-all duration-300"
      >
        <LifeBuoy className="w-5 h-5" />
        <span className="font-medium text-sm">Need help now?</span>
      </button>
      <CrisisDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
